// import React from 'react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import AppLayout from '../../layouts/app/AppLayout';
import AppIcons from '../../assets/images/icons';
import './custom.scss';
import SVGIcons from '../../assets/images/icons/svgIcons';
import ContactForm from '../../components/contactForm/ContactForm';
import Services from './services/homeServices';
import ApiCaller from '../../services/api/APICaller';
import S3ImageViewerWithFallback from '../../components/awsS3ImageViewer/ImgViewerWithFallback';

import { translateThis } from '../../helpers/language.helper';




const HomePage = () => {
    // custom home functions here
    const pageName = "WDP";

    const [dataArr, setDataArr] = useState([]);
    const [latestArticle, setLatestArticle] = useState([]);
    const [singleArticle, setSingleArticle] = useState([]);
    useEffect(() => {
        getDataArr();
    }, [])

    const getDataArr = () => {
        const apiCaller = new ApiCaller('news/latest-news');
        apiCaller.getList().then(({ data }) => {
            setDataArr(data.result)
            setLatestArticle(data.result ? data.result[0] : null)
            setSingleArticle(data.result ? data.result[1] : null)
        })
    }

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString('en-US', {
            // weekday: 'long', hour: '2-digit', minute: '2-digit',second: '2-digit',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
    };


    const impactList = [
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Sustainable',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Empowering',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Innovative',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Collaborative',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Impactful',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Holistic',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Transformative',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Humanitarian',
        },

    ];

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper f-wrp">
                <div className='project-main-banner f-wrp' id='home'>
                    <div className='main-banner-wrp f-wrp'>
                        <div className='row'>
                            <div className='col-lg-5 col-md-7 col-sm-12 col-xs-12'>
                                <div className='banner-con-wrp f-wrp'>
                                    <h4>{translateThis('Invest SECURELY with WDP')}</h4>
                                    <h1>{translateThis('Grow while making a difference')} <b>{translateThis('Worldwide')}</b></h1>
                                    <p>{translateThis('Partner with us in impactful, profitable initiatives that generate lasting value and significant returns. Drive positive change while maximizing your investment opportunities.')}</p>
                                    <div className='btn-wrp'>
                                        <Link to={'/investments'} className='sqr-btn'>{translateThis('Explore opportunities')}</Link>
                                        {/* <Link to={'/'} className='pln-btn'>{translateThis('Learn more')} <SVGIcons.LearnMoreArrow /></Link> */}
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-5 col-sm-12 col-xs-12'>
                                <div className='banner-img-wrp f-wrp'>
                                    <span><img src={AppIcons.banner} alt='banner' /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='contact-main-wrp f-wrp' id='contact-us'>
                    <div className='contact-main-container f-wrp'>
                        <div className='row'>
                            <div className='col-lg-7 col-md-6 col-sm-12 col-xs-12'>
                                <div className='contact-con-box f-wrp'>
                                    <div className='contact-con-sec f-wrp'>
                                        <h1 className='lftTitle'>{translateThis('Become a')} <b>{translateThis('member')}</b></h1>
                                        <div className='rytContent-box'>
                                            <h1>{translateThis('Collaborate')}</h1>
                                            <p>{translateThis("As a member of WDP you'll gain access to innovative projects that not only create significant returns but also make a positive difference in communities worldwide. Become a member today and be part of a global movement towards prosperity and progress.")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-5 col-md-6 col-sm-12 col-xs-12'>
                                <div className='contact-form-wrp f-wrp'>
                                    <ContactForm />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='our-story-wrp f-wrp' id='about'>
                    <div className='our-story-container f-wrp'>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className='our-story-box f-wrp'>
                                    <div className='storyHeader f-wrp'>
                                        <h1><b>{translateThis("Our story")}:</b><br />{translateThis("Driving global change")}</h1>
                                        <p>{translateThis("Discover our journey and commitment to creating a brighter, more sustainable world while creating wealth for our members.")}</p>
                                    </div>
                                    <div className='story-box-sec f-wrp'>
                                        <div className='each-story-box'>
                                            <div className='img-wrp'>
                                                <span><img src={AppIcons.mission} alt='mission' /></span>
                                                <h3>{translateThis("Mission")}</h3>
                                            </div>
                                            <p>{translateThis("A harmonious, enlightened and prosperous world where human rights are fully enjoyed and development is sustained.")}</p>
                                        </div>
                                        <div className='each-story-box'>
                                            <div className='img-wrp'>
                                                <span><img src={AppIcons.vision} alt='vision' /></span>
                                                <h3>{translateThis("Vision")}</h3>
                                            </div>
                                            <p>{translateThis("Empowering support in education, health, agriculture and economic development.")}</p>
                                        </div>
                                    </div>
                                    <div className='btn-sec-wrp f-wrp'>
                                        <div className='btn-wrp'>
                                            <Link to={'/about-us'} className='sqr-btn'>{translateThis("About us")} <SVGIcons.LearnMoreArrow /></Link>
                                            <Link to={'/global-presence'} className='pln-btn'>{translateThis("Global presence")} <SVGIcons.LearnMoreArrow /></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <span className='story-img'><img src={AppIcons.story} alt='mission' /></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='counter-main-wrp f-wrp'>
                    <div className='counter-item-block f-wrp'>
                        <div className='each-counter-items'>
                            <h1><CountUp
                                end={860}
                                enableScrollSpy
                                scrollSpyOnce suffix={translateThis("K")}
                                duration={2.75} /></h1>
                            <h5>{translateThis("Donations")}</h5>
                        </div>
                        <div className='each-counter-items'>
                            <h1><CountUp
                                end={480}
                                enableScrollSpy
                                scrollSpyOnce suffix=""
                                duration={2.75} /></h1>
                            <h5>{translateThis("Campaigns")}</h5>
                        </div>
                        <div className='each-counter-items'>
                            <h1><CountUp
                                end={699}
                                enableScrollSpy
                                scrollSpyOnce suffix={translateThis("K")}
                                duration={2.75} /></h1>
                            <h5>{translateThis("Happy people")}</h5>
                        </div>
                        <div className='each-counter-items'>
                            <h1><CountUp
                                end={68}
                                enableScrollSpy
                                scrollSpyOnce suffix={translateThis("+")}
                                duration={2.75} /></h1>
                            <h5>{translateThis("Volunteers")}</h5>
                        </div>
                    </div>
                </div>
                <div className='objective-main-wrp f-wrp'>
                    <div className='container'>
                        <div className='object-box f-wrp'>
                            <div className='object-con-box'>
                                <h1>{translateThis("WDP's")} <b>{translateThis("Objectives")}</b></h1>
                                <p>{translateThis("Advancing global welfare through initiatives like providing education, healthcare, clean water, and socio-economic empowerment.")}</p>
                            </div>
                            <div className='btn-wrp'>
                                <Link to={'/objectives'} className='sqr-btn'>{translateThis("Objectives")} <SVGIcons.LearnMoreArrow /></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='impact-main-wrp f-wrp' id='projects'>
                    <div className='impact-con-wrp'>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className='vid-wrp f-wrp'>
                                    <span><img src={AppIcons.Video} alt='impact video' /></span>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className='impact-con-box f-wrp'>
                                    <h1>{translateThis("Empowering change:")} <b>{translateThis("Our impactful projects")}</b></h1>
                                    <p>{translateThis("Explore our projects driving positive change worldwide. From education to healthcare, we're making a difference one initiative at a time. Join us in shaping a brighter future.")}</p>
                                    <ul>
                                        {impactList.map((element, key) => (
                                            <li key={key}>
                                                <span className='impact-icon'>{element.icon}</span>
                                                <p>{translateThis((element.title))}</p>
                                            </li>
                                        ))}
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='project-main-wrp f-wrp'>
                    <div className='project-main-container f-wrp'>
                        <div className='project-con-wrp f-wrp'>
                            <div className='project-grid-wrp'>
                                <div className='each-project-box project-1'>
                                    <span><img src={AppIcons.homeProj1} alt='project' /></span>
                                </div>
                                <Link to={'/projects/empowering-women'} className='each-project-box project-2'>
                                    <span><img src={AppIcons.homeProj2} alt='project' /></span>
                                    <p>{translateThis("Empowering women")}</p>
                                </Link>
                                <Link to={'/projects/sustainable-water-energy-solution'} className='each-project-box project-3'>
                                    <span><img src={AppIcons.homeProj3} alt='project' /></span>
                                    <p>{translateThis("Sustainable water & energy")}</p>
                                </Link>
                                <div className='each-project-box project-4'>
                                    <span><img src={AppIcons.homeProj4} alt='project' /></span>
                                </div>
                                <Link to={'/coming-soon'} className='each-project-box project-5'>
                                    <span><img src={AppIcons.homeProj5} alt='project' /></span>
                                    <p>{translateThis("Fostering")} <br />{translateThis("education")}</p>
                                </Link>
                            </div>
                            <div className='btn-wrp'>
                                <Link to={'/projects'} className='sqr-btn'>{translateThis("Projects")} <SVGIcons.LearnMoreArrow /></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='service-main-wrp f-wrp' id='investments'>
                    <div className='service-main-container f-wrp'>
                        <div className='service-main-header f-wrp'>
                            <h1>{translateThis("Strategic")} <b>{translateThis("investment services")}</b></h1>
                            <p>{translateThis("We offer top-tier investment consultation and services, delivering the best deals and prices for sustainable growth across diverse industries.")}</p>
                            <div className='btn-wrp'>
                                <Link to={'/investments'} className='pln-btn'>{translateThis("Investments")} <SVGIcons.LearnMoreArrow /></Link>
                            </div>
                        </div>

                        <div className='service-con-block f-wrp'>
                            <Services />
                        </div>

                    </div>
                </div>
                <div className='gapImg-wrp f-wrp' />
                <div className='article-main-wrp f-wrp' id='news'>
                    <div className='article-main-container f-wrp'>
                        <div className='article-main-header f-wrp'>
                            <div className='lft-content'>
                                <h1>{translateThis("Latest")} <b>{translateThis("articles")}</b></h1>
                                <p>{translateThis("Explore articles covering global development, sustainability, and social impact initiatives curated by WDP experts.")}</p>
                            </div>
                            <div className='ryt-content pc-btn-wrp'>
                                <div className='btn-wrp'>
                                    <Link to={'/latest-articles'} className='sqr-btn'>{translateThis("View more")} <SVGIcons.LearnMoreArrow /></Link>
                                </div>
                            </div>
                        </div>

                        <div className='article-main-block f-wrp'>
                            <div className="row">
                                <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12">
                                    {latestArticle && <Link to={`/individual-articles/${latestArticle?.id}`}
                                        state={{ latestArticle }} className='new-article-box mob-article-new f-wrp'>
                                        <span className='article-img'><S3ImageViewerWithFallback fileKey={latestArticle?.image} /></span>
                                        <div className='article-con-box f-wrp'>
                                            <span className='new-label'>{translateThis("New")}</span>
                                            <h5>{latestArticle?.title}</h5>
                                            <p>{latestArticle?.subTitle}</p>
                                        </div>
                                    </Link>}
                                    {singleArticle && <Link to={`/individual-articles/${singleArticle?.id}`}
                                        state={{ singleArticle }} className='single-article f-wrp'>
                                        <span className='article-img'><S3ImageViewerWithFallback fileKey={singleArticle?.image} /></span>
                                        <h5>{singleArticle?.title}</h5>
                                        <div className='auth-box f-wrp'>
                                            <span className='icon-img'><img src={singleArticle?.authIcon ? singleArticle.authIcon : AppIcons.auther} alt={singleArticle?.author} /></span>
                                            <div className='auth-detail'>
                                                <p>{singleArticle?.author}</p>
                                                <span>{formatDate(singleArticle?.createdAt)}</span>
                                            </div>
                                        </div>
                                    </Link>}
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                    <div className='article-list-wrp f-wrp'>
                                        {latestArticle && <Link to={`/individual-articles/${latestArticle?.id}`}
                                            state={{ latestArticle }} className='new-article-box pc-article-new f-wrp'>
                                            <span className='article-img'><S3ImageViewerWithFallback fileKey={latestArticle?.image} /></span>
                                            <div className='article-con-box f-wrp'>
                                                <span className='new-label'>{translateThis("New")}</span>
                                                <h5>{latestArticle?.title}</h5>
                                                <p>{latestArticle?.subTitle}</p>
                                            </div>
                                        </Link>}
                                        <div className='article-list-box f-wrp'>
                                            <ul>
                                                {dataArr.map((element, key) => (
                                                    <li key={key}>
                                                        <Link to={`/individual-articles/${element?.id}`}
                                                            state={{ element }} className='each-article-box'>
                                                            <span className='article-img'><S3ImageViewerWithFallback fileKey={element.image} /></span>
                                                            <div className='article-detail-box'>
                                                                <p><b>{element.title}</b></p>
                                                                {/* <p>{element.subTitle}</p> */}
                                                                <div className='auth-box f-wrp'>
                                                                    <span className='icon-img'><img src={element.authIcon ? element.authIcon : AppIcons.auther} alt={element.author} /></span>
                                                                    <div className='auth-detail'>
                                                                        <p>{element.author}</p>
                                                                        <span>{formatDate(element.createdAt)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mob-btn-wrp f-wrp'>
                                <div className='btn-wrp'>
                                    <Link to={'/latest-articles'} className='sqr-btn'>{translateThis("View more")} <SVGIcons.LearnMoreArrow /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default HomePage;